<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content class="mat-typography">

  <page-alert [message]="messageSuccess | translater" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
  <page-alert [message]="messageError | translater" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

    <form [formGroup]="form" class="example-form">
      <div>
        <mat-card style="display: flex; flex-direction: column; margin: 2vh 0 auto">
         
          <mat-form-field appearance="outline">
            <mat-icon matSuffix>account_circle</mat-icon>
            <mat-label>E-mail</mat-label>
            <input matInput placeholder="Email(email@example.com)" formControlName="email" />

            <mat-error *ngIf="form.get('email')?.hasError('required')"> O email é obrigatório. </mat-error>
            <mat-error *ngIf="form.get('email')?.hasError('email')"> Email inválido. </mat-error>
           
          </mat-form-field>
           

          <mat-form-field appearance="outline">
            <mat-label>Senha</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Esconder Senha'" [attr.aria-pressed]="hide">
              <mat-icon matSuffix>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="form.get('password')?.hasError('invalidPassword')">
              A senha deve conter pelo menos 1 número, 1 letra maiúscula, 1 letra minúscula e caracteres especiais.
            </mat-error>
            <mat-error *ngIf="form.get('password')?.hasError('required')"> A senha é obrigatória. </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Confirmar Senha</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password_confirmation" />
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Esconder Senha'" [attr.aria-pressed]="hide">
              <mat-icon matSuffix>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="form.get('password_confirmation')?.hasError('required')"> A confirmação da senha é obrigatória. </mat-error>
            <mat-error *ngIf="form.hasError('mismatch')"> As senhas não coincidem. </mat-error>
          </mat-form-field>         
        </mat-card>
      </div>
    </form>
</mat-dialog-content>     

<mat-dialog-actions align="end">     
  <button mat-button color="warn" [mat-dialog-close]="false">Fechar</button>      
  <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="register()" class="mt-2">Criar Especialista</button>
</mat-dialog-actions>